import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {ContainerWithListAndForm,
  PersonaDetails,
  PersonaCreating,
  PersonaTable} from '../../components/index';
import {COMPRESSED_MODE_TABLE, FULL_WIDTH_MODE_TABLE,
  MODES_SHOWING_CONTAINER_WITH_LIST_AND_FORM,
  STATES_ENTITY} from '../../constants';
import {
  changeEditModeAndPersonaState,
  createPersona,
  deletePersona,
  getDataToShowPersonaDetails,
  getDomains,
  getPersonas,
  resetSelectedPersonaIndex,
  resetPersonaData,
  updatePersona,
} from './action';
import {getPolicies} from '../../app-common/Policy/action';

function UsersConfigurer() {
  const dispatch = useDispatch();

  const [tableMode, setTableMode] = useState(FULL_WIDTH_MODE_TABLE);
  const [modeShowingContainer, setModeShowingContainer] =
    useState(MODES_SHOWING_CONTAINER_WITH_LIST_AND_FORM.SHOW_LIST_FULL_SCREEN);

  const domains = useSelector((store) => store.personaReducer.domains);
  const personas = useSelector((store) => store.personaReducer.personas);
  const selectedPersonaIndex = useSelector((store) => store.personaReducer.selectedPersonaIndex);
  const selectedPersona = useSelector((store) => store.personaReducer.selectedPersona);
  const isEditMode = useSelector((store) => store.personaReducer.isEditMode);
  const baseSettingsObject =
    useSelector((store) => store.personaEditFormReducer.baseSettingsObject);
  const directoryServices = useSelector((store) => store.personaEditFormReducer.directoryServices);
  const loggedAccount = useSelector((store) => store.userAccountsReducer.loggedAccount);
  const currentOrganization =
    useSelector((store) => store.userOrganizationsReducer.currentOrganization);

  const showCreateNewPersona = () => {
    dispatch(changeEditModeAndPersonaState(false, STATES_ENTITY.EDITING_CANCELED));
    setModeShowingContainer(MODES_SHOWING_CONTAINER_WITH_LIST_AND_FORM.SHOW_LIST_AND_CREATING_FORM);
  };

  const handlePersonaClick = (personaIndex) => {
    dispatch(getDataToShowPersonaDetails(personas[personaIndex].id, personaIndex));
    dispatch(changeEditModeAndPersonaState(false, STATES_ENTITY.NONE));
    setModeShowingContainer(
      MODES_SHOWING_CONTAINER_WITH_LIST_AND_FORM.SHOW_LIST_AND_ENTITY_DETAILS,
    );
  };

  const handleCancelEdit = () => {
    dispatch(changeEditModeAndPersonaState(false, STATES_ENTITY.EDITING_CANCELED));
  };

  const handleCancelCreating = () => {
    dispatch(changeEditModeAndPersonaState(false, STATES_ENTITY.EDITING_CANCELED));
    setModeShowingContainer(
      MODES_SHOWING_CONTAINER_WITH_LIST_AND_FORM.SHOW_LIST_FULL_SCREEN,
    );
  };

  const goBackToPersonas = () => {
    dispatch(resetSelectedPersonaIndex);
    setModeShowingContainer(MODES_SHOWING_CONTAINER_WITH_LIST_AND_FORM.SHOW_LIST_FULL_SCREEN);
  };

  const handleEditPersonaClick = () => {
    dispatch(changeEditModeAndPersonaState(true, STATES_ENTITY.EDITING));
  };

  const handleCreateNewPersona = () => {
    dispatch(createPersona({...baseSettingsObject, ...directoryServices}));
    setModeShowingContainer(
      MODES_SHOWING_CONTAINER_WITH_LIST_AND_FORM.SHOW_LIST_FULL_SCREEN,
    );
  };

  const handleSavePersona = () => {
    dispatch(updatePersona({...baseSettingsObject, ...directoryServices}))
      .then((success) => {
        if (success) {
          dispatch(changeEditModeAndPersonaState(false, STATES_ENTITY.NONE));
        }
      });
  };

  const handleDeletePersona = () => {
    dispatch(deletePersona(selectedPersona.id));
    setModeShowingContainer(
      MODES_SHOWING_CONTAINER_WITH_LIST_AND_FORM.SHOW_LIST_FULL_SCREEN,
    );
  };

  const isValidPersonaInfo = () =>
    !!baseSettingsObject?.name;

  useEffect(() => {
    setTableMode(
      modeShowingContainer === MODES_SHOWING_CONTAINER_WITH_LIST_AND_FORM.SHOW_LIST_FULL_SCREEN
        ? FULL_WIDTH_MODE_TABLE
        : COMPRESSED_MODE_TABLE,
    );
  }, [modeShowingContainer]);

  useEffect(() => {
    dispatch(resetPersonaData());
    dispatch(getPersonas());
    dispatch(getDomains());

    return () => {
      dispatch(resetPersonaData());
    };
  }, [loggedAccount, currentOrganization, dispatch]);

  const getForm = () => {
    let containerItem = null;
    switch (modeShowingContainer) {
      case MODES_SHOWING_CONTAINER_WITH_LIST_AND_FORM.SHOW_LIST_AND_CREATING_FORM:
        containerItem = (
          <PersonaCreating
            handleClickButtonCancel={handleCancelCreating}
            handleClickButtonSave={handleCreateNewPersona}
            getPolicies={getPolicies}
            domains={domains}
            isValidPersonaInfo={isValidPersonaInfo()}
          />
        );
        break;
      case MODES_SHOWING_CONTAINER_WITH_LIST_AND_FORM.SHOW_LIST_AND_ENTITY_DETAILS:
        containerItem = (
          <PersonaDetails
            persona={selectedPersona}
            getPolicies={getPolicies}
            domains={domains}
            handleClickButtonCancel={handleCancelEdit}
            handleClickButtonSave={handleSavePersona}
            handleClickButtonBack={goBackToPersonas}
            handleClickButtonDelete={handleDeletePersona}
            handleClickButtonEdit={handleEditPersonaClick}
            handleClickButtonCancelEdit={handleCancelEdit}
            isEditMode={isEditMode}
            isValidPersonaInfo={isValidPersonaInfo()}
          />
        );
        break;
      default:
        break;
    }
    return containerItem;
  };

  return (
    <ContainerWithListAndForm
      list={(
        <PersonaTable
          mode={tableMode}
          isEditMode={isEditMode}
          personas={personas} // TODO: Replace with personaTableData
          handleClickButtonNew={showCreateNewPersona}
          handleClickPersonaRow={handlePersonaClick}
          selectedPersonaIndex={selectedPersonaIndex}
        />
      )}
      form={getForm()}
    />
  );
}

UsersConfigurer.propTypes = {
};

export default UsersConfigurer;
